// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__JZazb","text":"SelectPayment_text__2Icgt","title":"SelectPayment_title__1kLq7","btn":"SelectPayment_btn__3AK22"};